export default {
  home: {
    title: "Швидкий запуск",
    fastRun: "Швидкий запуск"
  }
};
